import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import type { FreeTextStaticContent } from '@core-api/presentation/types/response';
import { FreeTextPresentation } from './FreeTextPresentation';

export function FreeTextPresentationDataHandler() {
  const { useQuestion, useConfig, InteractiveCanvasComponents } =
    usePresentationContext();
  const { enableAnimations } = useConfig();

  const slide = useQuestion();
  const staticContent = slide.staticContent as FreeTextStaticContent;

  return (
    <FreeTextPresentation
      styledBody={staticContent.styledBody as Record<string, unknown>}
      textAlignment={staticContent.textAlignment}
      shouldAnimate={enableAnimations}
      CanvasTitleArea={InteractiveCanvasComponents?.CanvasTitleArea}
      CanvasBodyArea={InteractiveCanvasComponents?.Body}
    />
  );
}
